module.exports = __webpack_public_path__ + "img/right.b08b8ce1.svg";